import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils';
import { ERROR_MESSAGE } from './constants';

/**
 * Fetch listing projects by briefId
 * @param {String} briefId
 * @param {Number} page
 * @param {Object} briefData
 * @param {Object} algoAbTestsConfig
 * @param {Number} totalPages
 * @returns {Promise<{projects}>}
 */
const getProjects = async({ briefId, page = 1, briefData, algoAbTestsConfig = {}, totalPages }) => {
    const requestUrl = pathfinder('logo_maker_buyer_ajax', { endpoint: 'getProjectListings' });

    try {
        const { data } = await axios.post(requestUrl, { page, briefId, briefData, algoAbTestsConfig, totalPages });
        return data;
    } catch (e) {
        logAPIError(e, { message: ERROR_MESSAGE, briefId, page, briefData, exception: JSON.stringify(e) });
    }
};

export default getProjects;
